import { render, staticRenderFns } from "./advertisementManage.vue?vue&type=template&id=2ff1d03a&scoped=true&"
import script from "./advertisementManage.vue?vue&type=script&lang=js&"
export * from "./advertisementManage.vue?vue&type=script&lang=js&"
import style0 from "./advertisementManage.vue?vue&type=style&index=0&id=2ff1d03a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff1d03a",
  null
  
)

export default component.exports